import { Component, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import {
  ValidationService, AuthenticationService, UtilityService,
  LicensePricingService, AdobeAnalyticsService
} from 'lib/ng2-sapmp/src/providers';
import { FetchCriteriaModel } from 'lib/ng2-sapmp/src/ui-components/custom-grid';
import { BreadCrumbModel, BreadCrumbService } from 'lib/ng2-sapmp/src/ui-components/breadcrumb';
import { PageLoaderService } from 'lib/ng2-sapmp/src/ui-components/page-loader';
import { UserProfileModel } from 'lib/ng2-sapmp/src/models';
import { DropdownModel } from 'lib/ng2-sapmp/src/ui-components/dropdown';
import { LicensesBuyProductService } from './shared';
import { LicensesBuyProductModel, LicensesBackInitModel } from './shared/model';
import { DROPDOWN, BREADCRUMBS } from 'config';
import { ReviewOrderProductModel } from '../manage-product/review-order-product';
import { KEY_CONFIG } from 'lib/ng2-sapmp/src/config/key-config';
import { MobilePivotModel } from 'lib/ng2-sapmp/src/ui-components/mobile-pivot/mobile-pivot.model';

declare var ENV_VAR: any; // global variable set in env.js file, imported in index.html
declare var logoutCurrentUser: any;
declare var ENV_PORTAL: any;

@Component({
  selector: 'app-licenses-buy-product',
  providers: [ValidationService, LicensesBuyProductService, LicensePricingService],
  templateUrl: './licenses-buy-product.component.html',
  styleUrls: ['./licenses-buy-product.component.scss']
})

export class LicensesBuyProductComponent implements OnInit, OnDestroy, AfterViewInit {
  buyProductForm: FormGroup;
  fanNumbers: Array<DropdownModel>;
  banNumbers: Array<DropdownModel>;
  breadCrumbs: BreadCrumbModel[];
  ctnNumbers: Array<string>;
  selectedFan: DropdownModel;
  selectedBan: DropdownModel;
  licensesBuyProductModel: LicensesBuyProductModel = new LicensesBuyProductModel();
  reviewOrder: ReviewOrderProductModel;
  dataForBackInit: LicensesBackInitModel;
  selectedCtn: string;
  editFbtn: boolean;
  editBbtn: boolean;
  editCtntn: boolean;
  singleCtn = false;
  shownFan: string;
  banMatch: boolean;
  ctnMatch = false;
  showFanDropDown: boolean;
  showBanDropDown: boolean;
  showCtnDropDown: boolean;
  banSectionEnable: boolean;
  ctnSectionEnable: boolean;
  continueToProdConfig: boolean;
  setError: boolean;
  fanDetails: any = null;
  user: UserProfileModel;
  ErrorMessage: string;
  selectedValueFlag: boolean;
  dropDownPlaceholder: string;
  dropbanDownPlaceholder: string;
  banField: boolean;
  showBan: string;
  invalidFan = false;
  fanMessage: string;
  formErrors = {
    'ban': '',
    'ctn': '',
    'qty': ''
  };
  validationMessages = {
    'ban': {
      'pattern': 'Please enter a valid numeric value.'
    },
    'ctn': {
      'pattern': 'Enter a wireless number.'
    },
    'qty': {
      'required': 'Number of licenses is a required field.',
      'pattern': 'Please enter a valid numeric value.'
    }
  };
  dataObj = {
    dcmCodes: [],
    quantity: 0
  };
  UpdatedQtyAmt = 0;
  UpdatedQtyCount = 0;
  volumeDiscount = [];
  showVolumeDiscount = false;
  unitPrice = 0;
  pivots: Array<MobilePivotModel>;
  fanScetion: boolean;
  priceCountValidated: boolean;
  feeType: string;
  estimatedAmount: number;
  unitTotalEstimatedAmount: number;
  licenseErrorFlag = false;
  licenseError: string ;
  banFlag = false;
  constructor(
    private pageloaderService: PageLoaderService,
    private formBuilder: FormBuilder,
    private validationService: ValidationService,
    private utilityService: UtilityService,
    private licensesBuyProductService: LicensesBuyProductService,
    private authenticationService: AuthenticationService,
    private licensePricingService: LicensePricingService,
    private breadCrumbService: BreadCrumbService,
    private adobeAnalyticsService: AdobeAnalyticsService,
    private router: Router
  ) {
    this.dropDownPlaceholder = 'Select';
    this.pivots = new Array<MobilePivotModel>();
    this.estimatedAmount = 0;
    this.unitTotalEstimatedAmount = 0;
  }

  ngOnInit() {
    this.pivots.push({ label: 'Console dashboard', routerLink: '/dashboard' });
    this.authenticationService.setLoginSuccessUrl(this.router.routerState.snapshot.url);
    if (sessionStorage.getItem('mappingFanData') === null) {
      this.router.navigate(['/home']);
    }else {
      this.pageloaderService.setPageLoaderStatus(false);
      this.showFanDropDown = true;
      this.buildForm();
      this.user = this.authenticationService.getUser();
      this.banSectionEnable = false;
      this.ctnSectionEnable = false;
      this.showBanDropDown = false;
      this.editFbtn = true;
      this.editBbtn = true;
      this.editCtntn = true;
      this.fanDetails = JSON.parse(sessionStorage.getItem('mappingFanData'));
      const specName = this.fanDetails.key;
      const addRemove = {
        'label': 'Bill product licenses to a different wireless number',
        'routerLink': this.router.routerState.snapshot.url
      };
      this.breadCrumbService.setCurrentBreadCrumb(addRemove);
      const tmp_review_data = JSON.parse(sessionStorage.getItem('reviewModel'));
      const tmp_init_data = JSON.parse(sessionStorage.getItem('dataForBackInit'));
      this.buildForm();
      if (this.user && tmp_review_data !== null && tmp_init_data !== null) {
        this.fanNumbers = tmp_init_data.fanNumbers;
        this.banNumbers = tmp_init_data.banNumbers;
        this.ctnNumbers = tmp_init_data.ctnNumbers;
        this.shownFan = tmp_init_data.showFan;
        this.selectedFan = tmp_init_data.selectedFan;
        this.selectedBan = tmp_init_data.selectedBan;
        this.selectedCtn = tmp_init_data.selectedCtn;
        let tempBan: any = this.selectedBan.name ? this.selectedBan.name : this.selectedBan;
        this.showBan = tempBan;
        this.dropDownPlaceholder = tmp_init_data.showFan;
        this.dropbanDownPlaceholder = tempBan;
        this.buyProductForm.get('ban').setValue(tempBan);
        this.buyProductForm.get('qty').setValue(tmp_init_data.increaseQty);
        this.buyProductForm.get('ctn').setValue(this.utilityService.formatTelephoneNumber(tmp_init_data.selectedCtn));
        this.ctnMatch = true;
        this.getFan('backinit');
        this.getBanDetails('backinit');
        this.fanScetion = false;
        this.continueToProdConfig = false;
      } else {
        this.fanScetion = true;
        sessionStorage.removeItem('reviewModel');
        sessionStorage.removeItem('dataForBackInit');
        this.buyProductForm.get('qty').setValue('1');
        this.getUpdatedPricing();
      }
    }
  }

  createFanDropDownList(fanNumbers, dropDownList) {
    for (let fan of fanNumbers) {
      // Allowing only unique id
      if (fan !== dropDownList[0].name) {
        let dropdown: DropdownModel = new DropdownModel();
        dropdown.name = fan;
        dropdown.value = fan;
        dropDownList.push(dropdown);
      }
    }
    return dropDownList;
  }

  getFan(state) {
    this.pageloaderService.setPageLoaderStatus(false);
    const fanList = this.user.fanList;
    let dropDownList = [{ 'name': 'Select', 'value': '' }];
    this.fanNumbers = this.createFanDropDownList(fanList, dropDownList);
    if (state === 'backinit') {
      if (fanList.length === 1) {
        this.editFbtn = false;
        this.shownFan = fanList[0];
      }
    } else {
      this.pageloaderService.setPageLoaderStatus(true);
      if (fanList.length === 1) {
        this.showFanDropDown = false;
        this.shownFan = fanList[0];
        this.dropbanDownPlaceholder = 'Select';
        this.pageloaderService.setPageLoaderStatus(false);
        this.invalidFan = false;
        this.fanMessage = '';
        this.editFbtn = false;
        this.licensesBuyProductService.validateSelectedFan(this.utilityService.getEnvConfig().getPricingUpdateForDCMcode,
        this.fanDetails.serviceOfferCode, this.buyProductForm.get('qty').value, this.shownFan)
        .subscribe(obj => {
          if (this.selectedBan === undefined) {
            this.getBanDetails('init');
          } else {
            this.pageloaderService.setPageLoaderStatus(true);
          }
          this.updatePriceDetails(obj, Number(this.buyProductForm.get('qty').value));
        }, err => {
          if (err.status === 404) {
            this.pageloaderService.setPageLoaderStatus(true);
            this.setError = false;
            this.invalidFan = true;
            this.fanMessage = 'Bill products using a different wireless number. Contact your administrator for proper permission.';
          }else {
          this.setErrorMessage(err);
          }
        });
      } else {
        this.selectedFan = this.fanNumbers[0];
      }
    }
  }

  selected(selectedValue: DropdownModel, selectedItem: string) {
    if (selectedItem === 'fan') {
      this.selectedFan = selectedValue;
      this.dropDownPlaceholder = selectedValue.name;
    } else {
      this.selectedBan = selectedValue;
      this.dropbanDownPlaceholder = selectedValue.name;
    }

    if ((this.selectedFan !== undefined && this.selectedFan.value.length !== 0 && selectedItem === 'fan') ||
      (this.selectedBan !== undefined && this.selectedBan.value.length !== 0 && selectedItem === 'ban')) {
      this.selectedValueFlag = true;
    } else {
      this.selectedValueFlag = false;
    }
  }

  selectGoFan() {
    if (this.selectedFan.name !== 'Select' && this.selectedFan.name !== '' && this.selectedFan.name !== undefined) {
      this.shownFan = this.selectedFan.name;
      this.dropDownPlaceholder = this.selectedFan.name;
      this.dropbanDownPlaceholder = 'Select';
      this.pageloaderService.setPageLoaderStatus(false);
      this.invalidFan = false;
      this.fanMessage = '';
      this.licensesBuyProductService.validateSelectedFan(this.utilityService.getEnvConfig().getPricingUpdateForDCMcode,
      this.fanDetails.serviceOfferCode, this.buyProductForm.get('qty').value, this.shownFan)
      .subscribe(obj => {
        this.updatePriceDetails(obj, Number(this.buyProductForm.get('qty').value));
        this.showFanDropDown = false;
        this.dropDownPlaceholder = this.selectedFan.name;
        this.initiateBan();
      }, err => {
        this.pageloaderService.setPageLoaderStatus(true);
        if (err.status === 404) {
          this.setError = false;
          this.invalidFan = true;
          this.fanMessage = 'Bill products using a different wireless number. Contact your administrator for proper permission.';
        }else {
          this.setErrorMessage(err);
        }
      });
    }
  }

  initiateBan() {
    this.getBanDetails('init');
    setTimeout(function () {
      if ( document.getElementById('ban_input') !== null) {
        document.getElementById('ban_input').focus();
      }
    }, 500);
  }

  editFan() {
    this.showFanDropDown = true;
    this.banSectionEnable = false;
    this.ctnSectionEnable = false;
    this.showBanDropDown = false;
    this.showCtnDropDown = false;
    this.ctnMatch = false;
    this.buyProductForm.get('ban').setValue('');
    this.buyProductForm.get('ctn').setValue('');
    this.selectedBan = this.banNumbers[0];
    this.selectedCtn = '';
    this.setError = false;
    this.ErrorMessage = '';
    this.continueToProdConfig = true;
  }

  getBanDetails(state) {
    const dropDownList = [];
    this.pageloaderService.setPageLoaderStatus(false);
    this.editBbtn = true;
    this.licensesBuyProductService.getBanDetailsGnFan(this.utilityService.getEnvConfig().getBanUrl, this.shownFan)
      .subscribe(banrespobj => {
        this.setError = false;
        this.ErrorMessage = '';
        this.banSectionEnable = true;
        this.showBanDropDown = true;
        this.pageloaderService.setPageLoaderStatus(true);
        if (state === 'backinit') {
          this.fanScetion = true;
          this.showFanDropDown = false;
          this.showBanDropDown = false;
          this.banNumbers = banrespobj.bansList;
          if (banrespobj.bansList.length === 1) {
            this.editBbtn = false;
            let optedBan = banrespobj.bansList[0].name ? banrespobj.bansList[0].name : banrespobj.bansList[0];
            this.selectedBan = { 'name': optedBan, 'value': optedBan };
            this.showBan = optedBan;
            this.showBanDropDown = false;
            this.buyProductForm.get('ban').setValue(banrespobj.bansList[0]);
            this.banNumbers = banrespobj.bansList;
          } else if (banrespobj.bansList.length <= 15) {
            let dropDownList = [{ 'name': 'Select', 'value': '' }];
            this.banNumbers = this.createFanDropDownList(banrespobj.bansList, dropDownList);
            this.banMatch = false;
          } else {
            this.banNumbers = banrespobj.bansList;
            this.banMatch = false;
            this.banField = true;
          }
          this.getCtnDetails('backinit');
        } else {
          if (banrespobj.bansList.length === 1) {
            this.editBbtn = false;
            this.showBanDropDown = false;
            let optedBan = banrespobj.bansList[0].name ? banrespobj.bansList[0].name : banrespobj.bansList[0];
            this.selectedBan = { 'name': optedBan, 'value': optedBan };
            this.showBan = optedBan;
            this.buyProductForm.get('ban').setValue(banrespobj.bansList[0]);
            this.banNumbers = banrespobj.bansList;
            this.getCtnDetails('init');
          } else if (banrespobj.bansList.length <= 15) {
            let dropDownList = [{ 'name': 'Select', 'value': '' }];
            this.banNumbers = this.createFanDropDownList(banrespobj.bansList, dropDownList);
            this.banMatch = false;
            this.banField = false;
          } else {
            this.banNumbers = banrespobj.bansList;
            this.banMatch = false;
            this.banField = true;
          }
        }
      }, err => {
        this.setErrorMessage(err);
      });
  }

  checkBanEntered(event) {
    if (!event || (event && event.keyCode !== KEY_CONFIG.tabKey)) {
      let tmp_ban;
      if (this.banField) {
        tmp_ban = this.buyProductForm.value.ban;
        tmp_ban = { 'name': tmp_ban, 'value': tmp_ban };
      } else {
        tmp_ban = this.selectedBan;
      }
      this.banMatch = false;
      if (this.banNumbers !== undefined && ((this.selectedBan && this.selectedBan.name !== 'Select' && this.selectedBan.name !== '') ||
        (tmp_ban && this.banField))) {
        for (let item of this.banNumbers) {
          if ((item.name ? item.name : item) === tmp_ban.name) {
            this.banMatch = true;
          }
        }
      }
      if (this.banMatch === false) {
        this.setError = true;
        this.ErrorMessage = 'Enter a valid billing account number.';
        this.banFlag = true;
        this.utilityService.loadFocusOnTop();
      } else if (this.banMatch === true) {
        this.setError = false;
        this.ErrorMessage = '';
        this.showBanDropDown = false;
        let optedBan = tmp_ban.name ? tmp_ban.name : tmp_ban;
        this.selectedBan = { 'name': optedBan, 'value': optedBan };
        this.showBan = optedBan;
        this.dropbanDownPlaceholder = optedBan;
        this.getCtnDetails('init');
      }
    }
  }

  editBan() {
    this.showBanDropDown = true;
    this.ctnSectionEnable = false;
    this.ctnMatch = false;
    this.setError = false;
    this.ErrorMessage = '';
    this.buyProductForm.get('ctn').setValue('');
    this.continueToProdConfig = true;
  }

  getCtnDetails(state) {
    this.pageloaderService.setPageLoaderStatus(false);
    this.ctnSectionEnable = true;
    this.editCtntn = true;
    if (state === 'backinit') {
      this.getUpdatedPricing();
      this.buyProductForm.get('ctn').setValue(this.selectedCtn);
      if (this.ctnNumbers.length === 1) {
        this.editCtntn = false;
        this.singleCtn = true;
        this.matchCtn(event);
      }
      this.pageloaderService.setPageLoaderStatus(true);
    } else {
      this.licensesBuyProductService.getCtnDetailsGnBan(this.utilityService.getEnvConfig().getCtnUrl, this.selectedBan)
        .subscribe(ctnrespobj => {
          this.setError = false;
          this.ErrorMessage = '';
          if (ctnrespobj.ctnList.length === 1) {
            this.ctnNumbers = ctnrespobj.ctnList;
            // making ctnMatch as true is like harding in this scenario
            this.ctnMatch = true;
            this.showCtnDropDown = false;
            this.buyProductForm.get('ctn').setValue(ctnrespobj.ctnList[0]);
            this.selectedCtn = this.utilityService.onBlurFormat(ctnrespobj.ctnList[0], 'dot');
            // this.selectedCtn = ctnrespobj.ctnList[0];
            this.continueToProdConfig = false;
            this.editCtntn = false;
            this.singleCtn = true;
            this.pageloaderService.setPageLoaderStatus(false);
            this.matchCtn(event);
          } else {
            this.ctnNumbers = ctnrespobj.ctnList;
            this.ctnMatch = false;
            this.showCtnDropDown = true;
          }
          this.pageloaderService.setPageLoaderStatus(true);
          if (state === 'backinit') {
            this.getUpdatedPricing();
          }
        }, err => {
          this.setErrorMessage(err);
        });
    }
  }

  ctnChange(event) {
    event = Object(event);
    this.setError = false;
    this.ErrorMessage = '';
    if (event) {
      if (event.keyCode === 46) {
        // not to except .
        event.preventDefault();
      }
      if ((event.charCode >= KEY_CONFIG.numericKey0 &&
        event.charCode <= KEY_CONFIG.numericKey9) ||
        event.keyCode === KEY_CONFIG.backSpaceKey ||
        event.type === 'input') {
        this.continueToProdConfig = true;
      }
    } else {
      this.continueToProdConfig = true;
    }
  }

  ctnBlur(event) {
    if (event.target.value.match('^[0-9]{1,100}$')) {
      const val = this.utilityService.onBlurFormat(event.target.value, 'dot');
      this.buyProductForm.get('ctn').setValue(val);
    }
  }

  ctnFocus(event) {
    const val = this.utilityService.onFocusFormat(event.target.value, 'dot');
    this.buyProductForm.get('ctn').setValue(val);
  }

  matchCtn(event) {
    this.pageloaderService.setPageLoaderStatus(false);
    let ctnStatus = '';
    const isDelayed = false;
    if ((!event || (event && event.keyCode === KEY_CONFIG.enter)) || this.singleCtn) {
      const tmp_ctn: string = this.buyProductForm.value.ctn.split('.').join('');
      if (this.ctnNumbers !== undefined) {
        if (this.ctnNumbers.find(data => (data.toString() === tmp_ctn))) {
          ctnStatus = 'matched';
          this.licensesBuyProductModel.class = 'API::ServiceSearchCriteria';
          this.licensesBuyProductModel.serviceOfferCodes = [this.fanDetails.serviceOfferCode];
          this.licensesBuyProductModel.serviceStatus = 'ACTIVE';
          this.licensesBuyProductService.getCtnUniqueValidate(this.user.companyId,
            this.utilityService.getEnvConfig().ctnValidationUrl + '?billingClientId=' + tmp_ctn + '&serviceType=buyWithDifferentCTN',
            this.licensesBuyProductModel)
            .subscribe(ctnObj => {
              if (ctnObj) {
                this.ctnMatch = true;
              } else {
                this.ctnMatch = false;
                ctnStatus = 'ChangeCtn';
              }
              this.selectedCtn = this.utilityService.formatTelephoneNumber(tmp_ctn);
              this.ctnSection(ctnStatus);
            }, err => {
              this.setErrorMessage(err);
            });
        } else {
          this.ctnMatch = false;
          ctnStatus = 'notValid';
          this.ctnSection(ctnStatus);
        }
      }
    } else {
      this.pageloaderService.setPageLoaderStatus(true);
    }
  }

  ctnSection(ctnStatus) {
    this.pageloaderService.setPageLoaderStatus(false);
    if (ctnStatus) {
      if (this.ctnMatch === false) {
        this.ErrorMessage = (ctnStatus === 'notValid' || ctnStatus === 'matched') ?
          'Enter a valid wireless number for the billing account.' :
          (ctnStatus === 'ChangeCtn' && !this.singleCtn) ?
            'The wireless number you entered already has a license for this product. Please enter a different number.' :
            (ctnStatus === 'ChangeCtn' && this.singleCtn) ?
              'This wireless number already has a license for this product.' : '';
        this.continueToProdConfig = true;
        this.setError = true;
        if (ctnStatus === 'ChangeCtn' && !this.singleCtn) {
          this.licenseError = 'License already assigned';
          this.licenseErrorFlag = true;
        }
        this.utilityService.loadFocusOnTop();
      } else if (this.ctnMatch === true) {
        this.continueToProdConfig = false;
        this.setError = false;
        this.ErrorMessage = '';
        this.showCtnDropDown = false;
      }
    }
    this.pageloaderService.setPageLoaderStatus(true);
  }

  editCtn() {
    this.showCtnDropDown = true;
    this.ctnMatch = false;
    this.continueToProdConfig = true;
  }

  getUpdatedPricing() {
    this.setError = false;
    this.ErrorMessage = '';
    this.pageloaderService.setPageLoaderStatus(false);
    let dcmArray = [];
    dcmArray.push(this.fanDetails.serviceOfferCode); // ag4104 remove hard coded code.
    this.dataObj.dcmCodes = dcmArray;
    this.dataObj.quantity = Number(this.buyProductForm.value.qty);
    if (this.shownFan) {
      this.dataObj['fan'] = this.shownFan;
    }
    this.licensePricingService.getPricingDetailsByQty(this.dataObj)
      .subscribe(priceData => {
        this.updatePriceDetails(priceData, this.dataObj.quantity);
        /* this.UpdatedQtyAmt = priceData[0].totalPrice;
        this.UpdatedQtyCount = this.dataObj.quantity;
        this.priceCountValidated = true;
        // this.unitPrice = this.UpdatedQtyAmt / this.dataObj.quantity;
        this.unitPrice = (priceData[0].customPrice) ? priceData[0].customPrice : priceData[0].unitPrice;
        this.estimatedAmount = (priceData[0].applicableDiscount) ? priceData[0].applicableDiscount : 0;
        this.unitTotalEstimatedAmount = (priceData[0].totalPriceWithDiscount) ? priceData[0].totalPriceWithDiscount : 0;
        if (priceData[0].price.length > 0) {
          this.volumeDiscount = priceData[0].price;
          this.volumeDiscount.forEach((value, index) => {
            if (value.customAmount) {
              this.volumeDiscount[index].amount = value.customAmount;
            }
          });
          this.feeType = priceData[0].feeType;
          this.showVolumeDiscount = true;
        } else {
          this.showVolumeDiscount = false;
        } */
        this.pageloaderService.setPageLoaderStatus(true);
        this.getFan('init');
      }, err => {
        this.priceCountValidated = false;
        this.setErrorMessage(err);
      });
  }

  checkOutOrder() {
    // Setting Data for back init functionalities
    this.dataForBackInit = new LicensesBackInitModel();
    this.dataForBackInit.fanNumbers = this.fanNumbers;
    this.dataForBackInit.banNumbers = this.banNumbers;
    this.dataForBackInit.ctnNumbers = this.ctnNumbers;
    this.dataForBackInit.showFan = this.shownFan;
    this.dataForBackInit.selectedFan = this.selectedFan;
    this.dataForBackInit.selectedBan = this.selectedBan;
    this.dataForBackInit.selectedCtn = this.selectedCtn;
    this.dataForBackInit.increaseQty = JSON.stringify(this.dataObj.quantity);
    sessionStorage.setItem('dataForBackInit', JSON.stringify(this.dataForBackInit));

    // setting data for review order page
    this.reviewOrder = new ReviewOrderProductModel();
    this.reviewOrder.product = this.fanDetails.key;
    this.reviewOrder.fan = this.shownFan;
    this.reviewOrder.ctn = this.selectedCtn;
    this.reviewOrder.ban = this.selectedBan.name;
    this.reviewOrder.initialLicense = this.dataObj.quantity;
    this.reviewOrder.modifiedLicense = this.dataObj.quantity;
    this.reviewOrder.serviceOfferCode = this.fanDetails.serviceOfferCode;
    this.reviewOrder.unitPrice = this.unitPrice;
    this.reviewOrder.initialAmount = this.UpdatedQtyAmt;
    // this.reviewOrder.totalAmount = this.UpdatedQtyAmt;
    this.reviewOrder.totalLicense = this.UpdatedQtyCount;
    this.reviewOrder.unitTotalAmount = this.UpdatedQtyAmt;
    this.reviewOrder.totalAmount = this.unitTotalEstimatedAmount > 0 ? this.unitTotalEstimatedAmount : this.UpdatedQtyAmt;
    this.reviewOrder.estimatedDiscount = this.estimatedAmount;
    this.reviewOrder.type = 'DiffCTN';
    this.reviewOrder.backUrl = 'licensesBuyProduct';
    sessionStorage.setItem('reviewModel', JSON.stringify(this.reviewOrder));
    this.router.navigate(['manageProduct/revieworderproduct']);
  }

  setErrorMessage(err) {
    this.pageloaderService.setPageLoaderStatus(true);
    this.setError = true;
    if (err.status === 500) {
    this.ErrorMessage = 'We couldn\'t complete your request. Please try again later.';
    } else if (err.status === 401) {
    this.ErrorMessage = 'Session expired, Please login again.';
    logoutCurrentUser(true);
    } else if (err.status === 400) {
    if (err.error) {
    this.ErrorMessage = err.error;
    } else if (err.error[0]) {
    this.ErrorMessage = JSON.stringify(err.error[0]);
    } else {
    this.ErrorMessage = 'Can not add more than max-qty';
    }
    } else {
    this.ErrorMessage = 'We couldn\'t complete your request. Please try again later.';
    }
    this.utilityService.loadFocusOnTop();
    this.adobeAnalyticsService.CreateSeriveAlertProperties(err.status, this.ErrorMessage, 'formResponse');
    }

  buildForm(): void { // creating formcontrol as a group that is used as formControlName in html

    this.buyProductForm = this.formBuilder.group({
      ban: ['', [
        Validators.pattern('^[0-9]{1,100}$')]],
      ctn: ['', [
        Validators.pattern('^[0-9\.\]{1,100}$')]],
      qty: ['', [
        Validators.required,
        Validators.pattern('^[1-9][0-9]{0,4}$')]]
    });

    this.validationService.validate(
      this.buyProductForm,
      this.formErrors,
      this.validationMessages);
  }

  handleError(error) {
    throw error;
  }

  ngAfterViewInit() {
    let dcmCode;
    try {
      dcmCode = this.fanDetails.serviceOfferCode;
    } catch (e) {
      console.log(e);
    }
    this.licensesBuyProductService.createPageLoadProperties(dcmCode,
      this.router.routerState.snapshot.url, 'BC Licenses Buy Product Pg');
  }

  private updatePriceDetails(priceData, qty) {
    try {
      this.UpdatedQtyAmt = priceData[0].totalPrice;
      this.UpdatedQtyCount = qty;
      this.priceCountValidated = true;
      this.unitPrice = (priceData[0].customPrice) ? priceData[0].customPrice : priceData[0].unitPrice;
      this.estimatedAmount = (priceData[0].applicableDiscount) ? priceData[0].applicableDiscount : 0;
      this.unitTotalEstimatedAmount = (priceData[0].totalPriceWithDiscount) ? priceData[0].totalPriceWithDiscount : 0;
      if (priceData[0].price.length > 0) {
        this.volumeDiscount = priceData[0].price;
        this.volumeDiscount.forEach((value, index) => {
          if (value.customAmount) {
            this.volumeDiscount[index].amount = value.customAmount;
          }
        });
        this.feeType = priceData[0].feeType;
        this.showVolumeDiscount = true;
      } else {
        this.showVolumeDiscount = false;
      }
    }catch (e) {
      this.priceCountValidated = false;
      console.log('Error in array length');
      let err: any;
      err['status'] = 500;
      this.setErrorMessage(err);
    }
  }

  ngOnDestroy() {
    this.pageloaderService.setPageLoaderStatus(true);
  }
}
